/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MissingInfoFollowUpRequestedItem } from './MissingInfoFollowUpRequestedItem';
import {
    MissingInfoFollowUpRequestedItemFromJSON,
    MissingInfoFollowUpRequestedItemFromJSONTyped,
    MissingInfoFollowUpRequestedItemToJSON,
    MissingInfoFollowUpRequestedItemToJSONTyped,
} from './MissingInfoFollowUpRequestedItem';

/**
 * 
 * @export
 * @interface MissingInfoFollowUp
 */
export interface MissingInfoFollowUp {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    screener_lead_id: string;
    /**
     * 
     */
    producer_type: MissingInfoFollowUpProducerTypeEnum;
    /**
     * 
     */
    producer_category: string;
    /**
     * 
     */
    status: MissingInfoFollowUpStatusEnum;
    /**
     * 
     */
    missing_info_summary: string;
    /**
     * 
     */
    requested_items: Array<MissingInfoFollowUpRequestedItem>;
    /**
     * 
     */
    generated_draft: string;
    /**
     * 
     */
    current_draft: string;
    /**
     * Opaque revision for the exact current draft
     */
    draft_revision: string;
}


/**
 * @export
 */
export const MissingInfoFollowUpProducerTypeEnum = {
    AutoDecisioning: 'auto_decisioning',
} as const;
export type MissingInfoFollowUpProducerTypeEnum = typeof MissingInfoFollowUpProducerTypeEnum[keyof typeof MissingInfoFollowUpProducerTypeEnum];

/**
 * @export
 */
export const MissingInfoFollowUpStatusEnum = {
    Draft: 'draft',
    Sending: 'sending',
    WaitingForResponse: 'waiting_for_response',
    SendFailed: 'send_failed',
    SendUnknown: 'send_unknown',
} as const;
export type MissingInfoFollowUpStatusEnum = typeof MissingInfoFollowUpStatusEnum[keyof typeof MissingInfoFollowUpStatusEnum];


/**
 * Check if a given object implements the MissingInfoFollowUp interface.
 */
export function instanceOfMissingInfoFollowUp(value: object): value is MissingInfoFollowUp {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('screener_lead_id' in value) || value['screener_lead_id'] === undefined) return false;
    if (!('producer_type' in value) || value['producer_type'] === undefined) return false;
    if (value['producer_type'] !== 'auto_decisioning') return false;
    
    if (!('producer_category' in value) || value['producer_category'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('missing_info_summary' in value) || value['missing_info_summary'] === undefined) return false;
    if (!('requested_items' in value) || value['requested_items'] === undefined) return false;
    if (!('generated_draft' in value) || value['generated_draft'] === undefined) return false;
    if (!('current_draft' in value) || value['current_draft'] === undefined) return false;
    if (!('draft_revision' in value) || value['draft_revision'] === undefined) return false;
    return true;
}

export function MissingInfoFollowUpFromJSON(json: any): MissingInfoFollowUp {
    return MissingInfoFollowUpFromJSONTyped(json, false);
}

export function MissingInfoFollowUpFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingInfoFollowUp {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'screener_lead_id': json['screener_lead_id'],
        'producer_type': json['producer_type'],
        'producer_category': json['producer_category'],
        'status': json['status'],
        'missing_info_summary': json['missing_info_summary'],
        'requested_items': ((json['requested_items'] as Array<any>).map(MissingInfoFollowUpRequestedItemFromJSON)),
        'generated_draft': json['generated_draft'],
        'current_draft': json['current_draft'],
        'draft_revision': json['draft_revision'],
    };
}

export function MissingInfoFollowUpToJSON(json: any): MissingInfoFollowUp {
    return MissingInfoFollowUpToJSONTyped(json, false);
}

export function MissingInfoFollowUpToJSONTyped(value?: MissingInfoFollowUp | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'screener_lead_id': value['screener_lead_id'],
        'producer_type': value['producer_type'],
        'producer_category': value['producer_category'],
        'status': value['status'],
        'missing_info_summary': value['missing_info_summary'],
        'requested_items': ((value['requested_items'] as Array<any>).map(MissingInfoFollowUpRequestedItemToJSON)),
        'generated_draft': value['generated_draft'],
        'current_draft': value['current_draft'],
        'draft_revision': value['draft_revision'],
    };
}

